import { useTranslation } from "react-i18next";

type Props = {
  loadFailed: boolean;
  hasEntries: boolean;
};

// A failed load only produces an error message while the list is empty. If entries are
// already on screen, the contexts keep them and the failure stays invisible, so the list
// silently shows an outdated state. This notice sits above such a list and says so.
export const StaleListNotice = (props: Props) => {
  const { t } = useTranslation();

  if (!props.loadFailed || !props.hasEntries) {
    return null;
  }

  return <div className="notification is-warning is-light py-2 px-3 is-size-7">{t("listRefreshFailed")}</div>;
};
